"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureDataScienceClient = void 0;
var client_1 = require("./client");
/**
 * @param token JWT token
 * @param apiKey API key
 */
function configureDataScienceClient(token, apiKey) {
    client_1.OpenAPI.TOKEN = token;
    if (apiKey) {
        client_1.OpenAPI.HEADERS = { 'x-api-key': apiKey };
    }
}
exports.configureDataScienceClient = configureDataScienceClient;
//# sourceMappingURL=configure.js.map